import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelToHuman'
})
export class CamelToHumanPipe implements PipeTransform {

  transform(value: string): string {
    return value.camelToHuman();
  }

}
